import * as React from "react";
import { Header, TitleSize } from "azure-devops-ui/Header";
import { Page } from "azure-devops-ui/Page";
import { commandBarItems } from "./PageExampleData";

import "./Page.Example.css";

export default class PageSimpleExample extends React.Component {
    public render() {
        return (
            <Page className="sample-page">
                <Header
                    title="Page Title"
                    commandBarItems={commandBarItems}
                    titleSize={TitleSize.Large}
                />
                <div className="page-content">
                    <div>Page content</div>
                </div>
            </Page>
        );
    }
}
